import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

export const getDataBeforeTargetKey: NClientsList.GetDataBeforeTargetKey = ({
  oldFilters,
  filtersArea,
  filterGroupIndex,
}) => oldFilters?.[filtersArea]?.[filterGroupIndex]?.Values;
